import { render } from "./instructor-certificate-modal.vue?vue&type=template&id=1e257e3a"
import script from "./instructor-certificate-modal.vue?vue&type=script&lang=js"
export * from "./instructor-certificate-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__